import { X } from "lucide-react";

export function Field({ label, children }) {
  return <div><label className="text-[12px] text-slate-400">{label}</label><div className="mt-1">{children}</div></div>;
}

export function Modal({ title, children, onClose, wide, testid }) {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60" onClick={onClose} data-testid={testid}>
      <div className={"card-surface rounded-xl p-5 w-full mx-4 max-h-[90vh] overflow-y-auto " + (wide ? "max-w-3xl" : "max-w-md")} onClick={(e) => e.stopPropagation()}>
        <div className="flex items-center justify-between mb-4">
          <h2 className="font-heading font-bold text-slate-100">{title}</h2>
          <button onClick={onClose} className="text-slate-500 hover:text-slate-200"><X size={18} /></button>
        </div>
        {children}
      </div>
    </div>
  );
}
